import { createContext, useContext } from 'react';
import { ScanHandler } from '../state';

type BarcodeScannerContextValue = {
    scannerEnabled: boolean;
    setScannerEnabled: (enabled: boolean) => void;
    activeTargetId: string | null;
    setActiveTargetId: (id: string | null) => void;
    registerTarget: (id: string, handler: ScanHandler) => () => void;
    clearActiveTargetId: (id: string) => void;
};

export const BarcodeScannerContext = createContext<BarcodeScannerContextValue | null>(null);

export const useBarcodeScanner = () => {
    const context = useContext(BarcodeScannerContext);

    if (!context) {
        throw new Error('useBarcodeScanner must be used within BarcodeScannerProvider');
    }

    return context;
};
